import {createSelector} from '@ngrx/store';
import {AppState} from '../states/app.state';

export class MitarbeiterDialogSelectors {
  private static select = {
    mitarbeiterDialog: (state: AppState) => state.mitarbeiterDialog,
  };

  public static isMitarbeiterDialogOpen = createSelector(this.select.mitarbeiterDialog, data => data?.isOpen ?? false);

  public static inhaberId = createSelector(this.select.mitarbeiterDialog, data => data?.inhaberId);

  public static mitarbeiter = createSelector(this.select.mitarbeiterDialog, data => data?.mitarbeiter);
}
